const uibModalInjectableFactory = ($injector) => {
    return $injector.get('$uibModal');
};

export let UibModalServiceProvider =
    {
        provide: 'UibModalInjectable',
        useFactory: uibModalInjectableFactory,
        deps: ['$injector']
    }


